import React from 'react';
import { Checkbox } from 'evergreen-ui';
import useMapShowGeoJSON from './useMapShowGeoJSON';

export default function MapViewGeoJSONCheckbox() {
  const { isShowGeoJSON, toggle } = useMapShowGeoJSON();

  const onChange = () => toggle();

  return (
    <Checkbox
      label="Показать бассейны"
      checked={isShowGeoJSON}
      onChange={onChange}
    />
  );
}
